module.exports = __webpack_public_path__ + "static/media/floor_tom_basic_beat.f5c075b2.png";